<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YriKFC/tc-custom/9781418552237.jpg?1740434170481" alt="This image is the cover for the book God's Promises for Your Every Need"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">God's Promises for Your Every Need
      </h1>
      <p class="bookDescription body article font2">
        <b>Celebrating the 25th Anniversary of God's Promises--over 15 million sold--</b><b><b><i>God's Promises for Your Every Need</i></b></b><b><b><b> </b></b></b><b><b><b><b>now features scripture in NKJV and a soft, richly colored leather-like casing. You will find comfort and hope in God's Word. No matter what your situation, God has a promise for you!</b></b></b></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Nelson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f1e1bcf